export const authenticationErrorMessages = {
    FULL_NAME_REQUIRED: 'Full name is required',
    FULL_NAME_TOO_SHORT: 'Full name is too short',
    EMAIL_REQUIRED: 'Email is required',
    ENTER_VALID_EMAIL: 'Please, enter a valid email',
    PASSWORD_REQUIRED: 'Password is required',
    PASSWORD_LENGTH_ERROR: 'Password should be at least 8 characters long',
    PASSWORD_CONFIRMATION_REQUIRED: 'Please, confirm your password',
    PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
    PHONE_NUMBER_REQUIRED: 'Phone number is required',
    ENTER_VALID_PHONE_NUMBER: 'Please, enter a valid phone number',
};

export const backendErrorMessages = {
    ALREADY_TAKEN_EMAIL:
        'Sorry, it seems that email address is already in use, please log in or sign up with a different email address',
    ALREADY_TAKEN_MOBILE: 'The mobile has already been taken.',
    INVALID_CREDENTIALS: "Sorry we didn't recognise your email or password, please try again",
    EMAIL_NOT_FOUND: 'The selected email is invalid.',
};

export const frontendErrorMessages = {
    ALREADY_TAKEN_EMAIL: 'This email has already been taken',
    ALREADY_TAKEN_MOBILE: 'This mobile number has already been taken',
    INVALID_CREDENTIALS: "Sorry, we didn't recognise your email or password, please try again",
    EMAIL_NOT_FOUND: "Couldn't find a user with this email",
};



// WEBPACK FOOTER //
// ./src/Constants/errorMessages.js